import { FetchDataResponse, GetListRequest, NextType } from '../types';

export enum PrincipalType {
	App = 1,
	User = 2,
}

export interface CreatePrincipalRequest {
	type: PrincipalType;
	name: string;
}

export interface Principal extends CreatePrincipalRequest {
	principal: string;
}

export interface GetListByPrincipalRequest extends GetListRequest {
	principal: string;
}

export interface GetListPrincipalResponse extends NextType {
	principals: Principal[];
}

export type ListPrincipalsResponse =
	FetchDataResponse<GetListPrincipalResponse>;
export type GetPrincipalResponse = FetchDataResponse<Principal>;
